var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.7,
    height: 65.581,
    viewBox: "0 0 63.7 65.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(-85.017 -405.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2088_",
    transform: "translate(193.067 385.802) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2271_",
    d: "M67.892,74.654a7.008,7.008,0,0,1-2.818-.537L42.531,66.2a1.374,1.374,0,0,1-.805-.671,1.47,1.47,0,0,1,0-1.074l5.233-15.029a1.4,1.4,0,0,1,1.744-.805l22.543,7.917a8.73,8.73,0,0,1,5.368,11.138l-.4,1.074A8.915,8.915,0,0,1,67.892,74.654ZM44.544,64.187l21.336,7.38a5.994,5.994,0,0,0,7.649-3.757l.4-1.074a5.994,5.994,0,0,0-3.757-7.649l-21.336-7.38L44.544,64.187Z",
    transform: "translate(7.522 1.346)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2096_",
    transform: "translate(19.622 44.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2270_",
    d: "M45,63.82a.493.493,0,0,1-.4-.134l-5.77-2.013a1.4,1.4,0,0,1-.805-1.744l3.623-10.2a1.374,1.374,0,0,1,.671-.805,1.47,1.47,0,0,1,1.073,0l5.77,2.013a1.4,1.4,0,0,1,.805,1.744l-3.623,10.2a1.374,1.374,0,0,1-.671.805A1.459,1.459,0,0,1,45,63.82Zm-4.16-4.16,3.221,1.073,2.684-7.649-3.221-1.074Z",
    transform: "translate(-13.36 -43.156)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2269_",
    d: "M44.436,60.438a.493.493,0,0,1-.4-.134L28.871,55.071l-2.281.4a1.353,1.353,0,0,1-1.208-.4,1.56,1.56,0,0,1-.268-1.342l2.55-7.38a1.534,1.534,0,0,1,1.073-.939,1.353,1.353,0,0,1,1.208.4l1.476,1.744,15.163,5.368a1.4,1.4,0,0,1,.805,1.744L45.644,59.5a1.374,1.374,0,0,1-.671.805c-.134,0-.268.134-.537.134ZM29,52.253a.493.493,0,0,1,.4.134l14.224,4.965.805-2.281L30.213,50.106a1.852,1.852,0,0,1-.537-.4l-.268-.268-1.073,2.952H28.6C28.871,52.253,28.871,52.253,29,52.253Z",
    transform: "translate(-17.762 -44.336)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2102_",
    d: "M28.181,55.738a1.006,1.006,0,0,1-.671-.134l-7.246-4.294a1.242,1.242,0,0,1-.537-1.61l1.476-4.16a1.65,1.65,0,0,1,1.476-.939L31,45.674a1.009,1.009,0,0,1,.939.671,1.3,1.3,0,0,1,.134,1.208L29.523,54.8a1.21,1.21,0,0,1-.805.805c-.134.134-.268.134-.537.134Zm-5.5-6.307,4.831,2.952,1.476-4.294-5.636-.805-.671,2.147Z",
    transform: "translate(-19.622 -44.6)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2095_",
    d: "M59.329,72.134a.493.493,0,0,1-.4-.134,1.4,1.4,0,0,1-.805-1.744l5.1-15.029a1.359,1.359,0,1,1,2.55.939L60.537,71.195a1.289,1.289,0,0,1-1.208.939Z",
    transform: "translate(13.133 3.329)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2094_",
    d: "M66.836,64.554a.493.493,0,0,1-.4-.134L44.427,56.771a1.359,1.359,0,0,1,.939-2.55L67.373,62a1.4,1.4,0,0,1,.805,1.744,1.476,1.476,0,0,1-1.342.805Z",
    transform: "translate(8.176 3.261)",
    stroke: "#f5b966",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M28.078,3a3.344,3.344,0,0,0-3.344,3.344l-.4,2.81a3.344,3.344,0,0,1-5.316,2.2l-2.271-1.7a3.344,3.344,0,0,0-4.729,0L9.653,12.017a3.344,3.344,0,0,0,0,4.729l1.7,2.271a3.344,3.344,0,0,1-2.2,5.316l-2.81.4A3.344,3.344,0,0,0,3,28.078v3.344a3.344,3.344,0,0,0,3.344,3.344l2.81.4a3.344,3.344,0,0,1,2.2,5.316l-1.7,2.271a3.344,3.344,0,0,0,0,4.729l2.364,2.364a3.343,3.343,0,0,0,4.729,0l2.271-1.7a3.344,3.344,0,0,1,5.316,2.2l.4,2.81A3.344,3.344,0,0,0,28.078,56.5h3.344a3.344,3.344,0,0,0,3.344-3.344l.4-2.81a3.344,3.344,0,0,1,5.316-2.2l2.271,1.7a3.343,3.343,0,0,0,4.729,0l2.364-2.364a3.344,3.344,0,0,0,0-4.729l-1.7-2.271a3.344,3.344,0,0,1,2.2-5.316l2.81-.4A3.344,3.344,0,0,0,56.5,31.422V28.078a3.344,3.344,0,0,0-3.344-3.344l-2.81-.4a3.344,3.344,0,0,1-2.2-5.316l1.7-2.271a3.344,3.344,0,0,0,0-4.729L47.483,9.653a3.344,3.344,0,0,0-4.729,0l-2.271,1.7a3.344,3.344,0,0,1-5.316-2.2l-.4-2.81A3.344,3.344,0,0,0,31.422,3ZM29.75,36.438a6.688,6.688,0,1,0-6.687-6.688A6.688,6.688,0,0,0,29.75,36.438Z",
    transform: "translate(82.017 405)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingProfileIcon);
export default __webpack_public_path__ + "static/media/SettingProfileIcon.ad16d3ed1fda60d56c5a89d9415d62f6.svg";
export { ForwardRef as ReactComponent };